import React from 'react';
import LegalDocument from '../../Components/LegalDocument';
import "./style.css";

const PrivacyPolicy = () => {
  return (
    <LegalDocument 
      documentType="privacy_policy"
      cssPrefix="privacypolicy"
    />
  );
};

export default PrivacyPolicy;